Postlogin = (function (my) {
    my.Student = {};
    const self = my.Student;
    self.init = function () {};

    return my;
}(Postlogin));
